﻿import React from "react";
import { showError } from "../../store/notifications/actions";
import { updateCurrentFrameData } from "../../store/storyline/actions";
import { Button, Toolbar } from "../../shared/components";
import CodeMirror, { type BasicSetupOptions } from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { EditorView } from "@codemirror/view";
import { vscodeDark } from "@uiw/codemirror-theme-vscode";
import { jsonParseReviver } from "../../shared/api-client";
import { eagerParsing, measureOnScroll } from "../../shared/utils/codemirror";
import { useAppSelector, useThunkDispatch } from "../../store";

// Extensions/setup must be referentially stable — @uiw/react-codemirror reconfigures the editor
// whenever these props change identity...
const EDITOR_EXTENSIONS = [json(), eagerParsing, measureOnScroll];
const EDITOR_SETUP: BasicSetupOptions = { lineNumbers: true, foldGutter: true };

function FrameData() {
    const frameData = useAppSelector(state => state.storyline.currentParagraph?.data);
    const editorRef = React.useRef<EditorView>(null);
    const dispatch = useThunkDispatch();

    const applyFrameDataChange = React.useCallback(() => {
        try {
            const newFrameData = JSON.parse(editorRef.current.state.doc.toString(), jsonParseReviver);
            dispatch(updateCurrentFrameData(newFrameData));
        }
        catch (ex) {
            dispatch(showError(`Failed to parse JSON: ${ex}`));
        }
    }, []);

    const editorDidMount = React.useCallback((view: EditorView) => {
        editorRef.current = view;
        setTimeout(() => view.dispatch({ selection: { anchor: 0 }, scrollIntoView: true }));
    }, []);

    return (
        <>
            <div className="framedata-panel">
                <CodeMirror
                    value={JSON.stringify(frameData, null, 2)}
                    theme={vscodeDark}
                    extensions={EDITOR_EXTENSIONS}
                    basicSetup={EDITOR_SETUP}
                    onCreateEditor={editorDidMount}
                />

                <Toolbar className="d-flex flex-row align-items-center justify-content-center gap-2">
                    <Button color="secondary" variant="contained" onClick={applyFrameDataChange}>Apply Changes</Button>
                </Toolbar>
            </div>
        </>
    );
}

export default React.memo(FrameData);